import React, { FC, memo } from "react";
import { ButtonProps } from "./Button.props";
import P from "../P/P";

const buttonStyles: Record<NonNullable<ButtonProps["appearance"]>, string> = {
	main: "bg-mainColor text-white hover:bg-opacity-90",
	secondary: "bg-grayOne text-textColor hover:bg-opacity-80",
	shadeTwo: "bg-shadeTwo text-maincolor hover:bg-opacity-80",
	white: "bg-white text-textColor border border-strokeColor",
	disabled: "bg-grayOne text-passiveColor cursor-not-allowed",
};

const Button: FC<ButtonProps> = ({
	children,
	appearance = "main",
	icon = null,
	rightIcon = null,
	paddingX = "px-6",
	paddingY = "py-2",
	className = "",
	width = "w-max",
	rounded = "rounded-lg",
	fontSize = "p3",
	textType = "regular",
	textClassName = "",
	...props
}) => {
	const buttonClasses = `
		transition-all duration-300 font-medium flex items-center justify-center gap-2 
		${width} ${paddingX} ${paddingY} ${rounded} 
		${buttonStyles[appearance as NonNullable<ButtonProps["appearance"]>]} 
		${className}
	`;

	return (
		<button
			className={buttonClasses}
			disabled={appearance === "disabled"}
			{...props}
		>
			{icon && <span className="mr-2">{icon}</span>}

			<P
				size={fontSize}
				type={textType}
				className={`${textClassName} ${
					appearance === "disabled" ? "cursor-not-allowed" : "cursor-pointer"
				}`}
			>
				{children}
			</P>

			{rightIcon && <span className="ml-2">{rightIcon}</span>}
		</button>
	);
};

export default memo(Button);
